import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Business from "./Business";
import Testimonial from "./Testimonial";

export default function Facility() {
    

    return (
        <>
            <div className="aboutus_bg" >
                <div className="aboutus-img-content">
                    <h1>Facilities Management</h1>
                </div>
            </div>

           
            <Container className="it-overview mt-5 mb-5" >
                {/* <h6>OVERVIEW</h6> */}
                <h3 className="text-center" style={{ color: '#0e2b5c', paddingBottom: '15px' }}>Streamlining Operations for Smarter Workspaces</h3>
                <div className="overview-container" style={{ padding: '0 12%', color: '#627792', fontSize: '18px', fontWeight: '500', lineHeight: '1.8' }}>
                    <p>Facilities management goes beyond maintenance—it’s about efficiency, sustainability, and seamless operations. Our digital solutions enable real-time monitoring, predictive maintenance, and cost optimization for a smarter approach. We offer intelligent space management, energy monitoring, and workforce automation to enhance workplace efficiency. With smart building technology, we help businesses create safe, cost-effective, and environmentally friendly environments.
                    </p>
                </div>
            </Container>

           
            {/**benefit */}

            <section className="py-5 text-light mb-5" style={{ backgroundColor: "#141b29" }} >
                {/* <h6 className="text-uppercase text-center text-info mb-2">Benefits to Facilities Management on</h6> */}
                <h2 className="text-center mb-5">Our Solutions for Facilities Management
                </h2>
                <Container>
                    <Row>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Smart Building Automation to Enhance Energy Efficiency</h5>
                                <p>With IoT-powered energy management, businesses can monitor and control lighting, HVAC, and power usage in real time. AI-driven automation adjusts energy consumption based on occupancy patterns, reducing waste and lowering costs. Smart sensors and predictive analytics help maintain optimal indoor conditions while ensuring compliance with sustainability standards. This results in an eco-friendlier and more cost-efficient workplace.
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Predictive Maintenance Tools for Reduced Downtime</h5>
                                <p>AI-powered predictive maintenance tools analyze real-time equipment data to detect early signs of wear and potential failures. By identifying issues before they escalate, businesses can schedule timely repairs, preventing costly breakdowns and disruptions. This proactive approach extends asset lifespan, minimizes unexpected expenses, and enhances overall operational efficiency. It also ensures compliance with safety regulations and improves workplace reliability.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>AI-Powered Workforce Management for Streamlined Operations</h5>
                                <p>AI-driven workforce management optimizes scheduling, tracks employee productivity, and automates administrative tasks such as payroll and attendance. Machine learning algorithms analyze workforce patterns to allocate resources effectively, reducing labor costs and increasing efficiency. Real-time insights help businesses make informed decisions on staffing, workload distribution, and employee performance. This ensures a balanced, high-performing workforce while improving job satisfaction and retention.
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Data-Driven Decision Making for Operational Excellence</h5>
                                <p>Businesses thrive on accurate insights, and AI-powered data analytics provide actionable intelligence for better decision-making. Advanced algorithms process vast amounts of data, uncovering trends, inefficiencies, and opportunities for growth. Predictive modeling helps organizations forecast demand, optimize processes, and enhance strategic planning. This data-centric approach enables companies to stay agile, competitive, and future-ready in a rapidly evolving market.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>

            <Business />
        </>
    )
}